import React from "react";
import "./events-client.scss";

const EventsClient = () => {
  return (
    <div className="eventsClientWrapper">
      <h3>События</h3>
      <div className="eventsClientContainer">
        {/*        <div className="eventsClientContentContainer">
          <label>Автоматическое событие</label>
          <div className="eventsClientContentFooter">
            <span>Робот</span>
            <span>16.08.2020 12:30</span>
          </div>
        </div>*/}

        <h4>Нет активных событий</h4>
      </div>
    </div>
  );
};

export default EventsClient;
